import { useEffect } from "react";
import Button from "../components/Button";
import { X, LogOut } from 'lucide-react';

export default function LogoutModal({ isOpen, onClose, onConfirm }) {

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        handleClose();
      }
    };

    let originalOverflow;

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = originalOverflow || "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-200"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl max-w-xl w-full px-3 transform animate-in slide-in-from-bottom-4 duration-300 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={handleClose}
          className="cursor-pointer absolute top-4 right-4 p-3 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          aria-label="Close modal"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="py-6 px-4 flex items-center gap-1">
          <LogOut className="w-5 h-5" />
          <h3 className="text-xl font-semibold text-gray-900">
            Confirm Logout
          </h3>
        </div>

        <div className="px-4 py-2">
          <p className="text-gray-600">
            Are you sure you want to log out? You'll need to sign in again to access your account.
          </p>
        </div>
        
        <div className="flex justify-end w-full">
          <div className="px-6 pb-6 flex gap-4 w-80">
            <button
              onClick={handleClose}
              className="cursor-pointer w-full bg-black text-white rounded-xl hover:bg-gray-800 transition"
            >
              Cancel
            </button>

            <Button
              onClick={onConfirm}
              className="cursor-pointer w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg hover:bg-red-700 transition"
            >
              <LogOut className="w-4 h-4" />
              Log Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}